<template>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <div class="page">
    <br>
    <img class="center" src="https://nft.doge-punks.io/img/doge.gif" width="75" height="75">    
    <h1> MUIC NFT Marketplace</h1>
    <router-link to="/market">
      <i class="fa fa-shopping-cart"></i> 
      Market 
    </router-link>
    <router-link to="/collection"> 
      <i class="fa fa-photo"></i>
      My Collection 
    </router-link>
    <router-link to="/topuser"> 
      <i class="fa fa-user"></i>
      Collector Ranking
    </router-link>
    <router-link style="float:right" to="/logout">         
      <i class="fa fa-sign-out"></i>
      Log out 
    </router-link> 
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  provide: {
    listedNFTs: [
      {
        id: 1,
        title: "Dogepunk NFT 1",
        price: 1,
        img: "https://www.doge-punks.io/img/1.png",
      },
      {
        id: 2,
        title: "Dogepunk NFT 2",
        price: 2,
        img: "https://www.doge-punks.io/img/2.png",
      },
      {
        id: 3,
        title: "Dogepunk NFT 3",
        price: 3,
        img: "https://www.doge-punks.io/img/3.png",
      },
      {
        id: 4,
        title: "Dogepunk NFT 4",
        price: 4,
        img: "https://www.doge-punks.io/img/4.png",
      },
      {
        id: 5,
        title: "Dogepunk NFT 5",
        price: 5,
        img: "https://www.doge-punks.io/img/5.png",
      },
      {
        id: 6,
        title: "Dogepunk NFT 6",
        price: 6,
        img: "https://nft.doge-punks.io/img/6.png",
      },
      {
        id: 7,
        title: "Dogepunk NFT 7",
        price: 7,
        img: "https://www.doge-punks.io/img/7.png",
      },
      {
        id: 8,
        title: "Dogepunk NFT 8",
        price: 8,
        img: "https://www.doge-punks.io/img/8.png", 
      },
      {
        id: 9,
        title: "SolanaMonkeyBusiness NFT 9",
        price: 9,
        img: "https://cdn.solanamonkey.business/gen2/1.png",
      },
      {
        id: 10,
        title: "SolanaMonkeyBusiness NFT 10",
        price: 10,
        img: "https://cdn.solanamonkey.business/gen2/3.png",
      },
      {
        id: 11,
        title: "SolanaMonkeyBusiness NFT 11",
        price: 11,
        img: "https://cdn.solanamonkey.business/gen2/4.png",
      },
      {
        id: 12,
        title: "SolanaMonkeyBusiness NFT 12",
        price: 12,
        img: "https://cdn.solanamonkey.business/gen2/7.png",
      },
      {
        id: 13,
        title: "SolanaMonkeyBusiness NFT 13",
        price: 13,
        img: "https://cdn.solanamonkey.business/gen2/2.png",
      },
      {
        id: 14,
        title: "SolanaMonkeyBusiness NFT 14",
        price: 14,
        img: "https://cdn.solanamonkey.business/gen2/5.png",
      },
      {
        id: 15,
        title: "SolanaMonkeyBusiness NFT 15",
        price: 15,
        img: "https://cdn.solanamonkey.business/gen2/6.png",
      },
      {
        id: 16,
        title: "SolanaMonkeyBusiness NFT 16",
        price: 16,
        img: "https://cdn.solanamonkey.business/gen2/8.png",
      },
      {
        id: 17,
        title: "SolanaMonkeyBusiness NFT 17",
        price: 17,
        img: "https://cdn.solanamonkey.business/gen2/17.png",
      },
      {
        id: 18,
        title: "SolanaMonkeyBusiness NFT 18",
        price: 18,
        img: "https://cdn.solanamonkey.business/gen2/18.png",
      },
        {
        id: 19,
        title: "SolanaMonkeyBusiness NFT 19",
        price: 19,
        img: "https://cdn.solanamonkey.business/gen2/19.png",
      },
      {
        id: 20,
        title: "SolanaMonkeyBusiness NFT 20",
        price: 20,
        img: "https://cdn.solanamonkey.business/gen2/20.png",
      },
      {
        id: 21,
        title: "SolanaMonkeyBusiness NFT 21",
        price: 21,
        img: "https://cdn.solanamonkey.business/gen2/21.png",
      },
    ],  
  },
};
</script>

<style>

body{
  background: darkblue;

}
a {
  background-color: darkmagenta; 
  border: 3p;
  border-radius: 3px;
  border-color: black;  
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  font-family: Helvetica;
  margin-right: 4px;
  align-items : center;
}
a.router-link-active {
  background-color: darkcyan;
}
a:hover {
  background-color: violet; 
  border: 3p;
  border-radius: 3px;
  border-color: black;  
  color: black;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  font-family: Helvetica;
  margin-right: 4px;
  align-items : center;
}
h1 {
  text-align: center;
  color:white;
  font-family: Arial, Helvetica, sans-serif;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;

}
/* span {
  background-color: orange; 
  border: 1rem;
  border-radius: 3px;
  color: black;
  padding: 15px 32px;
  text-align: center;
  text-decoration:black;
  display: inline-block;
  font-size: 16px;
  font-family: Helvetica;
  margin-right: 4px;
  align-items : center;
  border-color: black;
} */
</style>
